/**
 * Search page <title>: report the number of cards Bloomreach actually renders.
 *
 * Shopify writes the title from its own search.results_count before Bloomreach
 * runs, so it counts matching products while the page renders one card per
 * available variant. A search for "5004" reads "4 results found" in the tab and
 * "Showing 13 results" on the page. Rewriting the count after each render keeps
 * the two in step.
 */
(function () {
  var RESULT = '.blm-product-search__result';
  var CONTAINER = '.blm-product-search__results';

  // Anchored to the word so a numeric query ("5004") can't be mistaken for the
  // count. Locales that phrase it differently keep Shopify's title.
  var COUNT = /(\d[\d,]*)(\s+)(results?)/i;

  var original = document.title;

  function titleFor(count) {
    return original.replace(COUNT, function (match, digits, gap) {
      return count + gap + (count === 1 ? 'result' : 'results');
    });
  }

  function sync() {
    var count = document.querySelectorAll(RESULT).length;

    // The grid is empty mid-render as well as on a genuine miss, so leave the
    // title alone rather than flashing "0 results" on the way to the results.
    if (!count) return;

    var next = titleFor(count);
    if (next !== document.title) document.title = next;
  }

  function watch(container) {
    if (container.dataset.titleSync === 'true') return;
    container.dataset.titleSync = 'true';

    // Sorting, faceting and paging all re-render the grid in place.
    new MutationObserver(sync).observe(container, { childList: true, subtree: true });
    sync();
  }

  function scan() {
    var container = document.querySelector(CONTAINER);
    if (container) watch(container);
  }

  function init() {
    if (!COUNT.test(original)) return;

    scan();
    // Bloomreach builds the grid after its API call resolves.
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
